var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"compact-grid"},[_vm._l((_vm.values),function(value){return [_c('div',{key:value.id,staticClass:"tag_list_multiple_item"},[_vm._v(" "+_vm._s(value[_vm.keyName])+" "),_c('tags-detail',{attrs:{"tagLabels":value.tags}})],1)]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }